// import React, { useState, useCallback, useEffect, createContext, useMemo } from "react";
// import { Options } from "../../utils/Requests/Options";

// // Create the context
// export const OptionContext = createContext();

// const OptionContextProvider = ({ children }) => {
//   const [options, setOptions] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchOptions = useCallback(async () => {
//     setIsLoading(true);
//     setError(null);
//     try {
//       const response = await Options(); // Assumes this returns a JSON object with `settingFiled`
//       setOptions(response);
//     } catch (err) {
//       console.error("Failed to fetch options:", err);
//       setError(err);
//     } finally {
//       setIsLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchOptions();
//   }, [fetchOptions]);

//   const handleOptionToData = useCallback((searchLabel) => {
//     const settings = options?.settingFiled ?? [];

//     const found = settings.find((info) => info.label === searchLabel);
//     if (!found?.value || !Array.isArray(found.value)) return [];

//     return found.value.map((item) => ({
//       label: searchLabel === "Income" ? `${item} BDT` : item,
//       value: item,
//     }));
//   }, [options]);

//   const contextValue = useMemo(() => ({
//     options,
//     handleOptionToData,
//     isLoading,
//     error,
//     refetchOptions: fetchOptions,
//   }), [options, handleOptionToData, isLoading, error, fetchOptions]);

//   return (
//     <OptionContext.Provider value={contextValue}>
//       {children}
//     </OptionContext.Provider>
//   );
// };

// export default OptionContextProvider;


import React, { useState, useCallback, useEffect, createContext } from "react";
import { Options } from '../../utils/Requests/Options';
// import { optionSetter } from "../Redux/Slice/OptionSlice";
// import { useDispatch } from "react-redux";
export const optionContext = createContext();

const OptionContextProvider = ({ children }) => {

    const [options, setOptions] = useState(null)
    // const dispatch = useDispatch()

    const fetchOptions = useCallback(async () => {
        const response = await Options()
        // dispatch(optionSetter(response))
        setOptions(response)
    }, [])

    useEffect(() => {
        fetchOptions()
    }, [fetchOptions])

    // OptionContext To search data... Function
    const handleOptionToData = (search) => {
        let findSearch = options && options.settingFiled ? options.settingFiled.find(info => info.label === search) : null;
        if (!findSearch) return [];
        let info = [];

        if (search === "Income") {
            for (let i = 0; i < findSearch.value.length; i++) {
                info.push({ label: `${findSearch.value[i]} BDT`, value: findSearch.value[i] });
            }
        } else {
            for (let i = 0; i < findSearch.value.length; i++) {
                info.push({ label: `${findSearch.value[i]}`, value: findSearch.value[i] });
            }
        }
        return info;
    };

    const { Provider } = optionContext

    return(
        <Provider value={{options, handleOptionToData}}>
            {children}
        </Provider>
    );
}
export default OptionContextProvider;